import { combineReducers } from 'redux';

const historyLoading = (state = true, action) => {
  switch (action.type) {
    case 'SET_HISTORY_LOADING':
      return true;
    case 'SET_HISTORY_ERROR':
    case 'SET_HISTORY_LOAD_COMLETE':
    case 'SET_HISTORY':
      return false;
    default:
      return state;
  }
};

const historyError = (state = null, action) => {
  switch (action.type) {
    case 'SET_HISTORY_ERROR':
      return action.message;
    default:
      return state;
  }
};

const historyItems = (state = [], action) => {
  switch (action.type) {
    case 'SET_HISTORY': {
      const nextState = { ...state };
      nextState[action.history.receipt_no] = action.history;
      return nextState;
    }
    case 'SET_HISTORY_LIST': {
      return action.list;
    }
    default:
      return state;
  }
};

const historyLinks = (state = {}, action) => {
  switch (action.type) {
    case 'SET_HISTORY_LINKS': {
      return action.meta;
    }
    default:
      return state;
  }
};



export default combineReducers({
  historyItems,
  historyLinks,
  historyError,
  historyLoading,
});

export const getHistory = (state) => Object.values(state.historyItems);
export const getHistoryLoading = (state) => state.historyLoading;
export const getHistoryError = (state) => state.historyError;
